export default [
  {
    path: '/wishlist',  
    component: () => import('@/views/app/public/wishlist'),
    meta: {
      authRequired: true
    },
    children:[
      {
        path: '',
        name: 'WishList',
        component: () => import('@/views/app/public/wishlist/WishList')
       
      },
      {
        path: 'sale',
        name: 'HouseForSaleWishList',
        component: () => import('@/views/app/public/wishlist/HouseForSaleWishList')
       
      },
      {
        path: 'rental',
        name: 'HouseRentalWishList',
        component: () => import('@/views/app/public/wishlist/HouseRentalWishList')
       
      }
    ]
  }
  
]